









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapServer } from '../../../../src/api/installService';
@Component({
  name: 'MoneyType',
  components: {},
})
export default class MoneyType extends Vue {
  @Prop() private drawPoint: any;
  private xaxis: any = [
    '外贸企业',
    '跨境电商企业',
    '互市贸易企业',
    '海外仓企业',
    '其他企业',
  ];
  private pageTemporaryStorage: any;
  private mounted(): void {
    this.getData();
  }
  private getData(): void {
    const that = this;
    mapServer.getMoneyType().then((res: any) => {
      if (res.status === 200) {
        const da = res.data.data;
        let va: any = new Array(5).fill(0);
        const name: any = [];
        da.forEach((item: any) => {
          if (this.xaxis.indexOf(item.tradeName) !== -1) {
            va[this.xaxis.indexOf(item.tradeName)] = item.count;
          }
        });
        that.drawPie({
          name: this.xaxis,
          value: va,
        });
      }
    });
  }
  private drawPie(data: any) {
    const articleEchart: any = Vue.prototype.$echarts.init(
      document.getElementById('school'),
    );
    const colorArray: any = [
        {
            top: '#ff4c3d',
            bottom: 'rgba(255,76,61,.6)',
        },
        {
            top: '#EAEA26',
            bottom: 'rgba(234,234,38,.6)',
        },
        {
            top: '#834aff',
            bottom: 'rgba(131,74,255,.6)',
        },
        {
        top: '#ffa800',
        bottom: 'rgba(248,195,248,.6)',
        },
        {
            top: '#b250ff',
            bottom: 'rgba(100,255,249,.6)',
        },
        {
            top: '#1ace4a',
            bottom: 'rgba(100,255,249, 0.6)',
        },
        {
            top: '#4bf3ff',
            bottom: 'rgba(135,183,255,.6)',
        }, {
            top: '#f991ff',
            bottom: 'rgba(249,145,255,.6)',
        },
    ];
    const option: any = {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        title: {
            show: false,
        },
        tooltip: {
            trigger: 'item',
        },
        grid: {
            borderWidth: 0,
            top: '20px',
            left: '20%',
            right: '10%',
            bottom: '30px',
        },
        yAxis: {
            type: 'category',
            axisTick: {
                show: false,
                alignWithLabel: false,
            },
            inverse: 'true',
            axisLine: {
                show: false,
                lineStyle: {
                    color: '#fff',
                },
            },
            axisLabel: {
                textStyle: {
                    color: '#fff',
                },
            },
            data: data.name,
        },
        xAxis: {
            type: 'value',
            show: false,
        },
        series: [{
            type: 'bar',
            barWidth: '10px',
            data: data.value,
            animationDuration: 1500,
            label: {
                normal: {
                    show: true,
                    position: 'right',
                    formatter: '{c}',
                    color: '#fff',
                },
            },
            itemStyle: {
                normal: {
                    show: true,
                    color: (params: any) => {
                        const num: any = colorArray.length;
                        return {
                            type: 'linear',
                            colorStops: [{
                                offset: 0,
                                color: colorArray[params.dataIndex % num].bottom,
                            }, {
                                offset: 1,
                                color: colorArray[params.dataIndex % num].top,
                            }, {
                                offset: 0,
                                color: colorArray[params.dataIndex % num].bottom,
                            }, {
                                offset: 1,
                                color: colorArray[params.dataIndex % num].top,
                            }, {
                                offset: 0,
                                color: colorArray[params.dataIndex % num].bottom,
                            }, {
                                offset: 1,
                                color: colorArray[params.dataIndex % num].top,
                            }, {
                                offset: 0,
                                color: colorArray[params.dataIndex % num].bottom,
                            }, {
                                offset: 1,
                                color: colorArray[params.dataIndex % num].top,
                            }, {
                                offset: 0,
                                color: colorArray[params.dataIndex % num].bottom,
                            }, {
                                offset: 1,
                                color: colorArray[params.dataIndex % num].top,
                            },
                            ],
                        };
                    },
                    barBorderRadius: [ 10, 0, 10, 0],
                    borderWidth: 0,
                    borderColor: '#333',
                    barCategoryGap: '50%',
                },
            },
        },
        ],
        animationEasing: 'cubicOut',
    };
    articleEchart.setOption(option);
  }
}
